"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (_ref) {
    var props = _ref.props;
    var isDragging = props.isDragging;

    return !isDragging;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/dnd/canDrop/preventDropOnSelfPredicate.js
// module id = 454
// module chunks = 0